import React, { Component } from 'react';
import Modal from '../lib/modal-shim';

export class ModalChatPanel extends Component {

  render() {
    return (
      <Modal show={this.props.showPanel} onHide={this.props.onClose}>
        <Modal.Header closeButton className="chat-modal-header">
          <Modal.Title>Chat Panel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <ul className="chat">
              <li className="left "><span className="chat-img pull-left">
                <img src="http://placehold.it/50/55C1E7/fff&text=U" alt="User Avatar" className="img-circle" />
              </span>
                  <div className="chat-body">
                      <div className="header">
                          <strong className="primary-font">Jack Sparrow</strong> <small className="pull-right text-muted">
                              <span className="glyphicon glyphicon-time"></span>12 mins ago</small>
                      </div>
                      <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare
                          dolor, quis ullamcorper ligula sodales.
                      </p>
                  </div>
              </li>
              <li className="right"><span className="chat-img pull-right">
                  <img src="http://placehold.it/50/FA6F57/fff&text=ME" alt="User Avatar" className="img-circle" />
              </span>
                  <div className="chat-body">
                      <div className="header">
                          <small className=" text-muted"><span className="glyphicon glyphicon-time"></span>13 mins ago</small>
                          <strong className="pull-right primary-font">Bhaumik Patel</strong>
                      </div>
                      <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare
                          dolor, quis ullamcorper ligula sodales.
                      </p>
                  </div>
              </li>
              <li className="left"><span className="chat-img pull-left">
                  <img src="http://placehold.it/50/55C1E7/fff&text=U" alt="User Avatar" className="img-circle" />
              </span>
                  <div className="chat-body">
                      <div className="header">
                          <strong className="primary-font">Jack Sparrow</strong> <small className="pull-right text-muted">
                              <span className="glyphicon glyphicon-time"></span>14 mins ago</small>
                      </div>
                      <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare
                          dolor, quis ullamcorper ligula sodales.
                      </p>
                  </div>
              </li>
              <li className="right"><span className="chat-img pull-right">
                  <img src="http://placehold.it/50/FA6F57/fff&text=ME" alt="User Avatar" className="img-circle" />
              </span>
                  <div className="chat-body">
                      <div className="header">
                          <small className=" text-muted"><span className="glyphicon glyphicon-time"></span>15 mins ago</small>
                          <strong className="pull-right primary-font">Bhaumik Patel</strong>
                      </div>
                      <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare
                          dolor, quis ullamcorper ligula sodales.
                      </p>
                  </div>
              </li>
          </ul>
          <div className="clearfix" />
        </Modal.Body>
        <Modal.Footer>

            <textarea className="form-control" rows="3"></textarea>
            <hr/>
            <span className="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3 col-xs-12">
                <button className="btn btn-warning btn-lg btn-block" id="btn-chat">Send</button>
            </span>

        </Modal.Footer>
      </Modal>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/ModalChatPanel.js